var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPasswordReset = function SvgPasswordReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161,
    height: 130
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M72.348 62.297h17.304v-8.43c0-4.655-3.874-8.43-8.652-8.43s-8.652 3.775-8.652 8.43zM81 40.221c7.735 0 14.006 6.11 14.006 13.646v13.647H66.994V53.867c0-7.536 6.27-13.646 14.006-13.646"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D2D3",
    d: "M69.966 65.283h22.068V54.249c0-6.094-4.94-11.034-11.034-11.034s-11.034 4.94-11.034 11.034zM81 40.296c7.706 0 13.953 6.247 13.953 13.953V68.2H67.048V54.25c0-7.706 6.246-13.953 13.952-13.953"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#65D6F8",
    d: "M68.43 60.483c0-.888.337-1.697.889-2.306h26.773a3.17 3.17 0 0 1 3.164 3.18v22.37a3.17 3.17 0 0 1-3.164 3.18H69.319a3.42 3.42 0 0 1-.888-2.307z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.818 58.257h-7.133v28.65h7.133z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44C8DC",
    d: "M65.996 58.257h3.822a3.33 3.33 0 0 0-.929 2.3v24.05c0 .885.352 1.692.929 2.3h-3.822c-1.828 0-3.31-1.42-3.31-3.171V61.428c0-1.751 1.482-3.17 3.31-3.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6E70",
    d: "M77.05 70.704c0-2.937 3.273-5.117 6.407-3.164.297.186.55.435.738.73 1.629 2.553.423 5.199-1.71 6.056v3.961h-2.97v-3.961a3.91 3.91 0 0 1-2.465-3.622"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.28,
    d: "M77.816 70.032c0 1.873 1.168 3.476 2.825 4.14v4.093l-1.195.022v-3.841c-1.405-.564-2.396-1.923-2.396-3.512 0-1.058.44-2.205 1.148-2.892-.245.55-.382 1.35-.382 1.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0EDFF",
    d: "M93.862 61.428a3.17 3.17 0 0 0-3.166-3.17h5.453a3.17 3.17 0 0 1 3.166 3.17v22.308a3.17 3.17 0 0 1-3.166 3.17h-5.453a3.17 3.17 0 0 0 3.166-3.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E86342",
    d: "M119.299 78.846c-8.41 15.05-23.193 25.41-39.033 25.41-21.789 0-39.53-17.332-40.188-38.962l-25.09-1.246c0 36.052 29.225 65.278 65.278 65.278 29.416 0 54.289-19.457 62.448-46.204z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD13D",
    d: "M43.865 48.28c6.554-13.312 21.765-23.076 37.26-22.658 23.638.637 39.62 17.73 40.278 39.36l25 .848c0-36.053-29.225-65.277-65.278-65.277-29.416 0-54.289 19.457-62.448 46.203z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D64122",
    d: "M96.287 127.344a5.622 5.622 0 0 0-5.2-7.76h-6.737c-2.963 0-5.547-2.282-5.636-5.243a5.41 5.41 0 0 1 5.409-5.577h16.974c2.994 0 5.608-2.26 5.802-5.248a5.62 5.62 0 0 0-4.91-5.95c-6.587 4.24-14.029 6.69-21.723 6.69-21.789 0-39.628-17.986-40.286-39.615l-24.991-.593c0 36.053 29.224 65.278 65.277 65.278a65.4 65.4 0 0 0 16.021-1.982"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1BA33",
    d: "M81.126 25.622a40.05 40.05 0 0 1 17.049 3.786h1.452c2.995 0 5.608-2.26 5.802-5.248a5.62 5.62 0 0 0-5.61-5.996H85.218a5.41 5.41 0 1 1 0-10.82h8.998c2.587 0 4.887-1.689 5.59-4.075A65.3 65.3 0 0 0 81.125.552C51.71.552 26.838 20.01 18.678 46.756l22.68 5.746c10.75-20.326 23.928-26.88 39.769-26.88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD13D",
    d: "M120.534 64.785H103.27l28.906 28.906 28.906-28.906h-14.675z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E86342",
    d: "M40.857 65.093H58.12L29.213 36.187.31 65.093h14.675z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.5,
    d: "M127.381 36.588a3.591 3.591 0 0 1 6.621-1.931c7.443 11.694 8.404 22.56 7.9 29.615a3.592 3.592 0 0 1-7.164-.512c.43-5.978-.404-15.207-6.795-25.247a3.57 3.57 0 0 1-.562-1.925"
  }))));
};
export { SvgPasswordReset as ReactComponent };
export default __webpack_public_path__ + "ed7cfff2611fe25add4582b850dd17c2.svg";